import React from 'react';
import { CargoInputField, CargoCommentField } from './CargoTempLogReporting.style';
import OdfjellInputComponent, { InputChangeData } from '../../common/odfjell-input-component/OdfjellInputComponent';
import { MainButton } from '../../../styles/button.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CargoTemperatureLogEntry } from '../../../types/ViewModel/CargoTempLog/CargoTemperatureLog';
import { CargoTempLogOxygenUnitEnum } from '../../../enums/cargoTempLogOxygenUnitEnum';
import { MAX_OXYGEN_PER_CENT_VALUE, MAX_OXYGEN_PPM_VALUE, MAX_TEMPERATURE_VALUE, MAX_PRESSURE_VALUE } from '../CargoTemperatureLogUtils';

type CargoLogInputProps = {
    cargoLog: CargoTemperatureLogEntry;
    onChange: (changeObject: InputChangeData) => void;
    isReadOnly: boolean;
    fieldId: number;
    openComment?: (cargoLog: CargoTemperatureLogEntry) => void;
    isCommentsVisible: boolean;
    oxygenUnitType: string;
    tabIndex: number;
    className?: string;
};

const CargoLogInput: React.FC<CargoLogInputProps> = ({
    cargoLog,
    onChange,
    isReadOnly,
    fieldId,
    openComment,
    isCommentsVisible,
    oxygenUnitType,
    tabIndex,
    className = '',
}) => {
    if (!cargoLog) return <CargoInputField className={className} />;

    if (fieldId === 4) {
        if (!isCommentsVisible) return null;

        return (
            <CargoCommentField>
                <MainButton title={cargoLog?.comment ? 'Edit comment' : 'Add comment'} onClick={() => openComment(cargoLog)}>
                    <FontAwesomeIcon icon={cargoLog?.comment ? 'comment' : 'plus'} />
                </MainButton>
            </CargoCommentField>
        );
    }

    const getMaxValue = (): number => {
        if (fieldId === 2 && oxygenUnitType === CargoTempLogOxygenUnitEnum.PerMillion) {
            return MAX_OXYGEN_PPM_VALUE;
        } else if (fieldId === 2) {
            return MAX_OXYGEN_PER_CENT_VALUE;
        } else if (fieldId === 1) {
            return MAX_TEMPERATURE_VALUE;
        } else if (fieldId === 3) {
            return MAX_PRESSURE_VALUE;
        }
        return undefined;
    };

    return (
        <CargoInputField className={className}>
            <OdfjellInputComponent
                dataObject={cargoLog}
                isReadOnly={isReadOnly}
                type={'number'}
                onChange={onChange}
                value={cargoLog.value}
                disableUnit={true}
                max={getMaxValue()}
                leaveBlank
                tabIndex={tabIndex}
                validationInTooltip
            />
        </CargoInputField>
    );
};

export default CargoLogInput;
